export const TOGGLE_STARTER_COMPLETE = "TOGGLE_STARTER_COMPLETE";
export const TOGGLE_PARTICIPANT_COMPLETE = "TOGGLE_PARTICIPANT_COMPLETE";
export const TOGGLE_ACTIVE_COMPLETE = "TOGGLE_ACTIVE_COMPLETE";
export const SET_CAPTAIN_COMPLETE = "SET_CAPTAIN_COMPLETE";
